import { gql } from '@apollo/client';

export const CREATE_WAITING_LIST_ENTRY = gql`
  mutation createWaitingListEntry($input: CreateWaitingListInput!) {
    createWaitingListEntry(input: $input) {
      position
    }
  }
`;
